import styled from '@emotion/styled';

type ContainerProps = {
  $stacked?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-height: 48px;
  padding: ${({ $stacked }) => ($stacked ? '12px 16px' : '10px 16px 10px 14px')};
  border: 1px solid #4ec937;
  border-radius: ${({ $stacked }) => ($stacked ? '16px' : '999px')};
  background: #fff;
  box-shadow: 0 8px 24px rgba(38, 38, 38, 0.12);
`;

export const CheckIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #4ec937;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const TextWrap = styled.span<{ $stacked?: boolean }>`
  display: ${({ $stacked }) => ($stacked ? 'flex' : 'inline')};
  flex-direction: column;
  gap: ${({ $stacked }) => ($stacked ? '2px' : '0')};
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  line-height: 20px;
`;

export const Title = styled.strong`
  font-weight: 700;
  color: #262626;
`;

export const Message = styled.span`
  font-weight: 400;
  color: #575757;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-left: 4px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #575757;
  cursor: pointer;
  transition: opacity 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    opacity: 0.7;
  }
`;
